import { MenuEntry } from '@src/menu-entry';

export default [
    MenuEntry.create()
        .setRoute('procurement_project_list')
        .setAdditionalRoutes([
            'procurement_project_create',
            'procurement_project_edit',
        ]),
    MenuEntry.create()
        .setTitle('Lieferantenbelege')
        .setChildren([
            MenuEntry.create()
                .setRoute('procurement_purchase_invoice_list')
                .setAdditionalRoutes([
                    'procurement_purchase_invoice_create',
                    'procurement_purchase_invoice_edit',
                ]),
            MenuEntry.create()
                .setRoute('procurement_purchase_credit_note_list')
                .setAdditionalRoutes([
                    'procurement_purchase_credit_note_create',
                    'procurement_purchase_credit_note_edit',

                ]),
            MenuEntry.create()
                .setRoute('procurement_purchase_invoice_file_upload'),
        ]),
];
